<template>
    <div id="carouselExample" class="carousel slide" style="margin-top: 80px;"> 
        <div class="carousel-inner">
            <div v-for="(promo, index) in promos" :key="index" class="carousel-item" :class="{ active: index === 0 }">
                <img :src="promo.slide" class="d-block w-100" :alt="promo.nombre" />
            </div>
        </div>


        <!-- Controles de Bootstrap -->
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Anterior</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Siguiente</span>
        </button>
    </div>
    

</template>

<script>
export default {
    name: "PromosCarousel",
    data() {
        return {
            promos: []
        }
    },
    mounted() {
        this.fetchPromos()
    },
    methods: {
        async fetchPromos() {
            try {
                const url = "https://beauvoyage.net/api/banner";
                const response = await fetch(url);

                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }

                const data = await response.json(); // 👈 Parsear JSON directamente

                this.promos = data.megapromo.map(promo => ({
                    nombre: promo.nombre,
                    clv: promo.clv,
                    slide: promo.slide,
                    slidemobil: promo.slidemobil,
                    slidesmall: promo.slidesmall
                }));

                console.log("Promos cargadas:", this.promos);
            } catch (error) {
                console.error("Error al obtener promos:", error);
            }
        }

    }
}
</script>
